import script from "./UploadImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadImage.vue?vue&type=script&lang=ts&setup=true"

import "./UploadImage.vue?vue&type=style&index=0&id=8bcc7776&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bcc7776"]])

export default __exports__